import { IApplicationState } from '../../types/redux';

export const selectDefaultRedirectUrl = (state: IApplicationState) => state.calculator.defaultRedirectUrl;
